import { Reveal } from "@/components/Reveal";

const SPECS = [
  ["COLOUR", "Black / Off White"],
  ["FIT", "Oversized"],
  ["SIZES", "XS — XXL"],
  ["EDITION", "200 pieces"],
  ["PRICE", "₹2,000"],
  ["PACKAGING", "SHUTUP Box + Poster"],
];

export default function ProductDetails({ kicker = "08 — PRODUCT DETAILS" }) {
  return (
    <section data-testid="product-details-section" className="bg-paper text-ink pb-24 sm:pb-32">
      <div className="mx-auto max-w-4xl px-5 sm:px-10">
        <Reveal>
          <div className="border-t-2 border-black pt-16">
            <p className="font-sans text-xs font-semibold tracking-[0.35em] text-black/50 mb-4">{kicker}</p>
            <h2 className="font-display text-[clamp(2.4rem,6vw,5rem)] leading-[0.9]">THE BORING STUFF.</h2>
          </div>
        </Reveal>

        <Reveal delay={0.15} className="mt-12">
          <dl className="border-t border-black/20" data-testid="product-specs">
            {SPECS.map(([k, v]) => (
              <div key={k} className="grid grid-cols-2 gap-4 py-5 border-b border-black/20">
                <dt className="font-sans font-bold text-xs sm:text-sm tracking-[0.3em] text-black/60">{k}</dt>
                <dd className="font-sans font-semibold text-sm sm:text-base text-right">{v}</dd>
              </div>
            ))}
          </dl>
        </Reveal>

        <Reveal delay={0.2} className="mt-16">
          <p className="font-sans text-xs font-semibold tracking-[0.35em] text-black/50 mb-4">CARE</p>
          <h3 className="font-display text-[clamp(1.8rem,4.5vw,3.5rem)] leading-[0.95]">INSTRUCTIONS FOR USE.</h3>
          <ul className="mt-8 border-2 border-black divide-y-2 divide-black" data-testid="care-instructions">
            {[
              ["01", "DRY CLEAN & HAND WASH RECOMMENDED"],
              ["02", "WASH INSIDE OUT"],
              ["03", "DO NOT IRON ON PRINT"],
            ].map(([n, text]) => (
              <li key={n} className="flex items-center gap-5 px-5 py-5" data-testid={`care-item-${n}`}>
                <span className="font-display text-pink text-lg w-10 shrink-0">{n}</span>
                <span className="font-sans font-bold text-sm sm:text-base tracking-[0.12em]">{text}</span>
              </li>
            ))}
          </ul>
          <p className="font-hand text-2xl text-black/60 mt-5 -rotate-1">the print is loud. keep it that way.</p>
        </Reveal>
      </div>
    </section>
  );
}
